import { render, staticRenderFns } from "./BuildingEditDatesDeliveryTab.vue?vue&type=template&id=2e1f731e"
import script from "./BuildingEditDatesDeliveryTab.vue?vue&type=script&lang=ts"
export * from "./BuildingEditDatesDeliveryTab.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports